import { css } from 'lit';
export const badgeStyles = css `
    :host {
        display: inline-flex;
    }

    .hlx-badge {
        display: inline-flex;
        color: var(--hlx-text-color-inverted-default);
        border-radius: var(--hlx-radius-full);
        border: 2px solid var(--hlx-color-neutral-0);
        user-select: none;
        -webkit-user-select: none;
        cursor: inherit;
        z-index: 1002;
    }

    .hlx-badge-lg {
        height: 24px;
        min-width: 24px;
        padding: 0 var(--hlx-spacing-xs);
        font-family: var(--hlx-text-font-family-serif);
        font-size: var(--hlx-text-font-size-xs);
        line-height: var(--hlx-text-line-height-default);
        font-weight: var(--hlx-text-font-weight-medium);
        align-items: center;
        justify-content: center;
        letter-spacing: normal;
        white-space: nowrap;
    }
    .hlx-badge-md {
        height: 16px;
        width: 16px;
    }
    .hlx-badge-sm {
        height: 12px;
        width: 12px;
    }

    .hlx-badge-brand {
        background-color: var(--hlx-color-brand-default);
    }
    .hlx-badge-dark {
        background-color: var(--hlx-color-dark-default);
    }
    .hlx-badge-success {
        background-color: var(--hlx-color-success-default);
    }
    .hlx-badge-error {
        background-color: var(--hlx-color-error-default);
    }
    .hlx-badge-warning {
        color: var(--hlx-text-color-default);
        background-color: var(--hlx-color-warning-default);
    }
    .hlx-badge-info {
        background-color: var(--hlx-color-info-default);
    }

    .hlx-badge-disabled {
        background-color: var(--hlx-color-neutral-60);
    }
`;
//# sourceMappingURL=badge.styles.js.map